import { baseApi } from './baseApi';

const doctorApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDoctors: build.query({
      query: (queryParameters) => ({
        url: '/doctor/all',
        method: 'GET',
        params: queryParameters,
      }),
      providesTags: ['doctor'],
    }),
    getSingleDoctor: build.query({
      query: (id: string) => ({
        url: `/doctor/${id}`,
        method: 'GET',
      }),
      providesTags: ['doctor'],
    }),
    postDoctor: build.mutation({
      query: (data) => ({
        url: '/doctor/create/',
        method: 'POST',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['doctor'],
    }),
    updateDoctor: build.mutation({
      query: ({ id, data }: { id: string; data: any }) => ({
        url: `/doctor/update/${id}`,
        method: 'PATCH',
        data,
        credentials: 'include',
      }),
      invalidatesTags: ['doctor'],
    }),
    deleteDoctor: build.mutation({
      query: (doctorId) => ({
        url: `/doctor/delete/${doctorId}`,
        method: 'DELETE',
        credentials: 'include',
      }),
      invalidatesTags: ['doctor'],
    }),
  }),
});

export const {
  useGetDoctorsQuery,
  useGetSingleDoctorQuery,
  usePostDoctorMutation,
  useUpdateDoctorMutation,
  useDeleteDoctorMutation,
} = doctorApi;
